import React, {useEffect, useRef} from "react";
import '../styles.scss';
import {TypeAheadClearButton} from "./TypeaheadClearButton";
import {TypeAheadSearchMagnifier} from "./TypeAheadSearchMaginfier";
import {TypeAheadSuggestions} from "./TypeaheadSuggestions";
import clearIcon from "../../../../icons/clear_icon.svg";
import {TypeaheadLayoutProps} from "../props";
import {definedValue, nil} from "../../../../utils/input";

const TypeAheadSearchLayout = ({
  placeholder,
  notFoundText,
  enterKeyHint,
  filteredOptions,
  role,
  onFocus,
  onMouseEnter,
  onBlur,
  onMouseLeave,
  onClickInput,
  onKeyDown,
  showSuggestions,
  handleOnChange,
  handleClear,
  handleKeyUp,
  handleSuggestionClick,
  displaySuggestions,
  doSearch,
  focus,
  displayClear,
  searchedValue,
  closeIcon = clearIcon,
  displaySearchIcon = false,
  inputType = 'text',
}: TypeaheadLayoutProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (focus) {
      inputRef.current?.focus();
    }
  }, [focus]);
  const displayClose = definedValue(displayClear, !!searchedValue.length);
  console.log('TypeAheadSearchLayout ', {notFoundText, filteredOptions});
  return (
    <div className='typeahead-search' aria-expanded={showSuggestions}>
      <div className='typeahead-search__input-container'>
        <label className='typeahead-search__input-label' htmlFor='searchInputTypeAhead'>
          {placeholder}
        </label>
        <input
          ref={inputRef}
          className='typeahead-search__input'
          type={inputType}
          value={searchedValue}
          onChange={handleOnChange}
          placeholder={placeholder}
          id='searchInputTypeAhead'
          aria-controls='typeahead-search-suggestions'
          aria-autocomplete='list'
          aria-labelledby="searchInputTypeAhead"
          name='searchInputTypeAhead'
          onFocus={onFocus}
          onBlur={onBlur}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={onClickInput}
          onTouchEnd={() => inputRef.current?.focus()}
          onKeyDown={onKeyDown}
          onKeyUp={handleKeyUp}
          {...(enterKeyHint ? { enterKeyHint } : {})}
          {...(role ? { role } : {})}
        />
        <TypeAheadClearButton handleClear={handleClear} closeIcon={closeIcon} display={displayClose} />
        <TypeAheadSearchMagnifier display={displaySearchIcon} doSearch={doSearch} />
      </div>
      <TypeAheadSuggestions
        filteredOptions={filteredOptions}
        search={searchedValue}
        notFoundText={notFoundText}
        handleSuggestionClick={definedValue(handleSuggestionClick, nil)}
        display={displaySuggestions} />
    </div>
  );
}

export {TypeAheadSearchLayout};